import { EmptyStateBase } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export default function EmptyStateNothingFound() {
  const { t } = useTranslation();
  return (
    <EmptyStateBase
      emoji={":shrug:"}
      title={t("common:nothing_found")}
      description={t("common:no_results_were_found")}
    />
  );
}
